import { helpers } from 'wix-restaurants-js-sdk';
import _ from 'lodash';
import moment from 'moment';
import RestaurantHelper from '@wix/wixrest-utils/dist/openrest-helpers/Restaurant';
import { DeliveryTypes } from './constants';

const OrderHelper = helpers.Order;

function parseTime(time) {
  if (time === 'asap') {
    return moment();
  } else {
    throw new Error('Only time=asap is supported at the moment');
  }
}
export const getDeliveryInfo = ({ organization, address }) => {
  const latLng = _.get(address, 'latLng');
  const deliveryTime = new moment(); // todo masha temp , should pass actual delivery time
  return RestaurantHelper.getDeliveryInfo(null, organization, latLng, deliveryTime, moment);
};

function calcFullDeliveryFee({ manualDeliveryFee, address, organization }) {
  const deliveryInfo = getDeliveryInfo({ address, organization });
  if (manualDeliveryFee.enabled) {
    return manualDeliveryFee.amount;
  } else if (deliveryInfo) {
    return _.get(deliveryInfo, 'charge', 0);
  } else {
    return getMostExpensiveDeliveryFee(organization);
  }
}

export function getPriceComponentsAndOrderCharges({
  dispatchType,
  dispatchTime,
  orderItems,
  tip,
  source,
  platform,
  chargesV2,
  timezone,
  organization,
  address,
  manualDeliveryFee,
}) {
  const orderCharges = OrderHelper.getOrderCharges({
    dispatchType,
    dispatchTime: parseTime(dispatchTime),
    orderItems,
    tip,
    source,
    platform,
    chargesV2,
    timezone,
  });

  const priceComponents = getPriceComponents({
    chargesV2,
    orderCharges,
    orderItems,
    organization,
    address,
    tip,
    manualDeliveryFee,
    dispatchType,
  });

  return { priceComponents, orderCharges };
}

export function getPriceComponents({
  chargesV2,
  orderCharges,
  orderItems,
  organization,
  address,
  tip = 0,
  numberOfPaymentMethods = 1,
  paymentAssociation = [],
  manualDeliveryFee = { enabled: false },
  ppd = false,
  dispatchType,
}) {
  if (!dispatchType) {
    throw new Error('CALLED getPriceComponents WITH NO DISPATCH TYPE!!!!');
  }

  const tax = Math.max(OrderHelper.sumTaxCharges({ chargesV2, orderCharges }), 0);
  const total = Math.max(OrderHelper.calculateTotalOrder({ orderItems, orderCharges }), 0);
  const discountSubtotal = orderCharges.reduce((pre, cur) => {
    const charge = _.find(chargesV2, (c) => c.id === cur.chargeId);
    return pre + (charge.type === 'discount' ? cur.amount : 0);
  }, 0);

  const fullDeliveryFee = calcFullDeliveryFee({ manualDeliveryFee, address, organization });

  const ppdShouldPayDeliveryFee = () => {
    return paymentAssociation.length !== 0;
  };

  const deliveryFee =
    dispatchType === DeliveryTypes.TAKEOUT
      ? 0
      : ppd
      ? ppdShouldPayDeliveryFee()
        ? fullDeliveryFee / numberOfPaymentMethods
        : 0
      : fullDeliveryFee; // we

  return {
    subtotal: total - tax - tip,
    tax,
    deliveryFee,
    tip,
    total: total + deliveryFee,
    discountSubtotal,
  };
}

export function getMostExpensiveDeliveryFee(organization) {
  const deliveries = _.filter(organization.deliveryInfos, (di) => di.type === 'delivery');
  const charges = _.map(deliveries, (d) => d.charge);
  return _.max(charges) || 0;
}
